import SidebarMenuBlocks from "../../components/adminNavigation/SidebarMenuBlocks";

import logo_image from "../../assets/images/Dancebrite_Primary_Logo-No_BG.png";
import icon from "../../assets/images/fav.png";
import { useSelector } from "react-redux";

const UserSidebar = ({ isMenuOpen }) => {
  const { lang } = useSelector((state) => state?.langProvider);
  const { selectedOrganizationDetails } = useSelector(
    (state) => state?.organization
  );
  const user_role = selectedOrganizationDetails?.data?.verificationData?.role;

  const userSidebarMenu = [
    {
      _id: "Home",
      menuTitle: "Home",
      menuData: [
        {
          _id: "home",
          menuLabel: "Home",
          menuLink: "/",
          menuIcon: "fa-light fa-house",
          menuIconColor: "text-primary",
        },
      ],
    },
    {
      _id: "Events",
      menuTitle: "Events",
      menuData: [
        // {
        //   _id: "Artists",
        //   menuLabel: "Artist",
        //   menuLink: `/${lang}/user/artist`,
        //   menuIcon: "fa-light fa-user-music",
        //   menuIconColor: "text-primary",
        // },
        {
          _id: "Events",
          menuLabel: "Events",
          menuLink: `/${lang}/user/events`,
          menuIcon: "fa-light fa-calendar-days",
          menuIconColor: "text-primary",
        },
      ],
    },
    // {
    //   _id: "Organization",
    //   menuTitle: "Organization",
    //   menuData: [
    //     {
    //       _id: "Organizations",
    //       menuLabel: "Organization",
    //       menuLink: `/${lang}/user/organization`,
    //       menuIcon: "fa-light fa-building-memo",
    //       menuIconColor: "text-primary",
    //     },
    //   ],
    // },
    {
      _id: "order",
      menuTitle: "Order Management",
      menuData: [
        {
          _id: "order",
          menuLabel: "Orders",
          menuLink: `/${lang}/user/order`,
          menuIcon: "fa-light fa-file-chart-column",
          menuIconColor: "text-primary",
        },
      ],
    },
    ...(user_role !== "promoter"
      ? [
          {
            _id: "reporting",
            menuTitle: "Reporting",
            menuData: [
              {
                _id: "reporting",
                menuLabel: "Reporitng",
                menuLink: `/${lang}/user/reporting`,
                menuIcon: "fa-light fa-chart-mixed",
                menuIconColor: "text-primary",
              },
            ],
          },
          // {
          //   _id: "wishlist",
          //   menuTitle: "Wishlist",
          //   menuData: [
          //     {
          //       _id: "wishlist",
          //       menuLabel: "Wishlist",
          //       menuLink: `/${lang}/user/wishlist`,
          //       menuIcon: "fa-regular fa-heart",
          //       menuIconColor: "text-primary",
          //     },
          //   ],
          // },
          {
            _id: "enquiry",
            menuTitle: "Enquiry",
            menuData: [
              {
                _id: "enquiry",
                menuLabel: "Enquiry",
                menuLink: `/${lang}/user/enquiry`,
                menuIcon: "fas fa-regular fa-question-circle",
                menuIconColor: "text-primary",
              },
            ],
          },
        ]
      : []),
    {
      _id: "overview",
      menuTitle: "Organization Overview",
      menuData: [
        {
          _id: "overview",
          menuLabel: "Organization overview",
          menuLink: `/${lang}/user/organization/overview`,
          menuIcon: "fa-light fa-gear",
          menuIconColor: "text-primary",
        },
      ],
    },
  ];

  return (
    <div className="relative w-full h-full py-4">
      <div
        className={
          "relative overflow-auto scroll-smooth scrollbar scrollbar-1 h-full space-y-2 transition-all duration-100 flex flex-col" +
          (isMenuOpen ? "" : " divide-transparent")
        }
      >
        {Array.isArray(userSidebarMenu) &&
          userSidebarMenu?.map((item, index) => {
            if (item) {
              return (
                <SidebarMenuBlocks
                  key={item._id}
                  menuTitle={item.menuTitle}
                  menuData={item.menuData}
                  isMenuOpen={isMenuOpen}
                  icon={icon}
                  divClasses={item.divClasses}
                />
              );
            }
            return null;
          })}
      </div>
    </div>
  );
};

export default UserSidebar;
